<template>
    <div>
        <el-tooltip class="item" effect="dark" :content="$t('groupDashboardTooltip')" placement="left" popper-class="popper-cls">
            <span :class="pieLoading ? 'dashboard-btn noActive' : 'dashboard-btn active'" @click="openDraw()">
                <img :src="dashboard_icon" alt="" class="history-icon" width="100%">
            </span>
        </el-tooltip>
        <el-drawer
                class="drawer-wrapper"
                :title="$t('groupDashboardTooltipDrawer')"
                size="55%"
                :visible.sync="drawer"
                :append-to-body="true"
                :modal-append-to-body="false"
                :modal="false"
                :direction="direction"
                :before-close="handleClose">
            <div>
                <div id="pieEcharts" class="pie-cls"></div>
                <div class="table-context-cls">
                    <el-radio-group v-model="unitRadio" class="radio-cls" @change="changeRadio">
                        <el-radio :label="1">{{ $t('LIMIT_NUM') }}</el-radio>
                        <el-radio :label="2">%</el-radio>
                    </el-radio-group>

                    <el-tabs v-model="activeTab" @tab-click="handleClick">
                        <el-tab-pane :label="$t('TABLE_HEAD_EntityList2')" name="0"></el-tab-pane>
                        <el-tab-pane :label="$t('TABLE_HEAD_Category')" name="1"></el-tab-pane>
                    </el-tabs>
                    <summary-table :tableData="tableData" :unitRadio="unitRadio" :dashboardTableLoading="dashboardTableLoading"/>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
    import * as echarts from 'echarts';
    import summaryTable from './summary-table'
    import { debounce } from '@/utils'
    export default {
        name: "dashboard",
        data(){
            return {
                myChart: null,
                drawer: false,
                direction: 'rtl',
                unitRadio: 1,
                activeTab: '0',
                tableData: [],
                dashboard_icon: require(`@/assets/img/icon-statisticaldata.svg`)
            }
        },
        props: {
            dashboardData: Object,
            pieLoading: Boolean,
            dashboardTableLoading: Boolean
        },
        watch: {
            'dashboardData.tableData': {
                handler: function (val, oldval) {
                    this.tableData = val
                },
                deep: true
            }
        },
        components: {
            summaryTable
        },
        mounted() {
            this.__resizeHandler = debounce(() => {
                if (this.myChart) this.myChart.resize()
            }, 350)
            window.addEventListener('resize', this.__resizeHandler)
        },
        beforeDestroy() {
            if (!this.myChart) {
                return
            }
            window.removeEventListener('resize', this.__resizeHandler)
            this.myChart.dispose()
            this.myChart = null
        },
        methods: {
            openDraw(){
                if(this.pieLoading){
                    return
                }
               this.drawer = true
                this.$nextTick(() =>{
                    this.initPie()
                    this.initTableData()
                })
            },
            handleClose(done) {
                this.activeTab = '0'
                this.$emit('chooseTab',this.activeTab)
                done();
            },
            initTableData(){
                this.unitRadio = 1
                this.tableData = this.dashboardData.tableData
            },
            initPie(){
                // 基于准备好的dom，初始化echarts实例
                this.myChart = echarts.getInstanceByDom(document.getElementById('pieEcharts')); //有的话就获取已有echarts实例的DOM节点。
                if (this.myChart == null) { // 如果不存在，就进行初始化。
                    this.myChart = echarts.init(document.getElementById('pieEcharts'));
                }
                // let sum = this.dashboardData.pieData.due + this.dashboardData.pieData.overdue + this.dashboardData.pieData.revisionRequired + this.dashboardData.pieData.uploaded + this.dashboardData.pieData.accepted
                // 指定图表的配置项和数据
                var option = {
                    title: {
                        text: 'PBC summary',
                        left: 'left',
                        show: false
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b0}: {c0} <br /> 占 {d0}%'
                    },
                    legend: {
                        show: true,
                        orient: 'vertical',
                        right: '2%',
                        icon: "circle",
                        formatter: (name) => {
                            let num = 0
                            name = name != null? name.trim() : name
                            switch(name){
                                case '待提交':
                                case 'Initiated': num = this.dashboardData.pieData.initiated; break;
                                case '已提交给集团项目组':
                                case 'Submitted To Group': num = this.dashboardData.pieData.submittedToGroup; break;
                                case '需修订':
                                case 'Revision Required': num = this.dashboardData.pieData.revisionRequired; break;
                                case '集团项目组已审阅':
                                case 'Approved By Group Team': num = this.dashboardData.pieData.approvedByGroupTeam; break;
                            }
                            return  name + '  '+ num;
                        }
                    },
                    // color:['#ffc000', '#bf2049', '#0292d9', '#fd0100', '#009946'],
                    color:['#989898','#1e49e2','#fd349c','#269924','#00c0ae'],
                    series: [
                        {
                            name: 'summary',
                            type: 'pie',
                            radius: '75%',
                            center: ['40%', '50%'],
                            label: {
                                show: true,
                                formatter: '{b0}\n {c0}【{d0}%】'
                            },
                            data: [
                                {value: this.dashboardData.pieData.initiated, name: this.$t('ECHANGE_STATUS._1')},
                                {value: this.dashboardData.pieData.submittedToGroup, name: this.$t('ECHANGE_STATUS._2')},
                                {value: this.dashboardData.pieData.revisionRequired, name: this.$t('ECHANGE_STATUS._3')},
                                {value: this.dashboardData.pieData.approvedByGroupTeam, name: this.$t('ECHANGE_STATUS._4')},
                            ],
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                };

                // 使用刚指定的配置项和数据显示图表。
                this.myChart.setOption(option);
                this.myChart.on('click', this.clickPie)
            },
            clickPie(params){
                this.drawer = false
                this.activeTab = '0'
                this.$emit('chooseState',params.data)
            },
            handleClick(tab) {
                this.tableData = []
                this.unitRadio = 1
                this.$emit('chooseTab',tab.name)
            },
            changeRadio(){
                if(this.unitRadio == 1){
                    this.tableData = this.dashboardData.tableData
                } else {
                    this.tableData = this.dashboardData.tableData2
                }
            }
        }
    }
</script>

<style scoped>
    .dashboard-btn {
        position: fixed;
        z-index: 10;
        top: 340px;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        font-size: 22px;
        text-align: center;
        border-radius: 4px 0 0 4px;
        cursor: pointer;
        transition: right .3s cubic-bezier(.9, 0, .3, .7);
        pointer-events: auto;
        color: #ffff;
    }
    .active{
        background: #7213ea;
    }
    .noActive{
        background-color: #eee;
    }
    .drawer-wrapper ::v-deep .el-drawer .el-drawer__header{
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 15px;
    }
    .pie-cls{
        width: 100%;
        height:30vh;
    }
    .table-context-cls{
        width: 98%;
        margin: 10px auto;
    }
    .radio-cls{
        display: flex;
        justify-content: flex-end;
    }
    .history-icon {
        position: absolute;
        width: 22px;
        top: 50%;
         left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
    }
</style>